import * as _ from 'lodash';
import { IListItem } from '@nkr/models/index';
import { FormEvent } from 'react';
import { Button, FormControl } from 'react-bootstrap';

interface IProps {
    languageId: number,
    search: string,
    languageList: IListItem[],
    onLanguageChange: (originTypeId: number) => void,
    onSearchChange: (search: string) => void,
    onFilterSearch: () => void
}

const Filter = (props: IProps) => {
    const handleLanguageChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onLanguageChange(parseInt(e.currentTarget.value));
    };

    const handleSearchChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onSearchChange(e.currentTarget.value);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                <div style={{ marginRight: 5 }}>Search:</div>
                <FormControl
                    style={{ width: 400 }}
                    value={props.search}
                    placeholder='Search across all fields...'
                    onChange={handleSearchChange}
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                <div style={{ marginRight: 5 }}>Missing&nbsp;Text&nbsp;(by&nbsp;Language):</div>
                <FormControl
                    componentClass='select'
                    value={props.languageId}
                    onChange={handleLanguageChange}
                >
                    <option value={999}>- All Languages -</option>
                    {props.languageList.map((language, index) =>
                        <option key={index} value={language.id}>{language.description}</option>
                    )}
                </FormControl>
            </div>

            <div style={{width: 100}}>
                <Button className='btn-block btn-sm' bsStyle='primary' onClick={props.onFilterSearch}>Search</Button>
            </div>
        </div>
    );
}

export default Filter;